import React from "react";
import banimage from "../../assets/banner-min.webp";
import img1 from "../../assets/kaha-banner.webp";

const Hero1 = () => {

  return (
    <div
      className="max-h-[1080px] h-screen min-h-[544px] md:min-h-[700px] w-full bg-center text-white bg-no-repeat bg-cover"
      style={{ backgroundImage: `url(${banimage})` }}
    >
      <div className="inset-0 bg-[rgba(0,0,0,0.6)] max-h-[1080px] h-screen min-h-[520px] md:min-h-[700px]">
        <div className="flex w-full h-full justify-center px-4">
          <div className="xl:w-2xl py-4 w-full">
            {/* Hero Section */}
            <div className="h-full flex justify-between items-center mt-8">
              <div className="flex flex-col items-center lg:items-start gap-4 w-full">
                <div className="w-full text-4xl sm:text-[52px] text-center lg:text-left xl:text-[64px] text-white leading-snug font-bold">
                  Tag your location, Simplify your life
                </div>
                <div className="text-base text-center md:text-left md:text-[22px] font-light text-white">
                  Let's move to the digital era of location sharing. Let's share
                  our tags.
                </div>

                <div className="text-[#16A951] font-bold text-[22px] lg:mt-8">
                  Kaha! One{" "}
                  <span className="bg-[#16A951] px-2 py-1 rounded-md text-white">
                    tag
                  </span>{" "}
                  solution
                </div>

                {/* New Section: Kaha Community and Story */}
                <div className="mt-12 text-center lg:text-left">
                  <p className="text-lg text-white mb-4">
                    <strong>Join the Story:</strong><br />
                    Kaha's story is an ongoing journey - a tapestry woven by the experiences of its users. Download the app, explore, connect, and be a part of something bigger. As you discover Nepal through Kaha, you become a storyteller yourself, adding your own thread to the rich fabric of this remarkable country.
                  </p>
                  <p className="text-lg text-white">
                    It's where hearts connect, and heritage thrive.
                  </p>
                </div>

                {/* Buttons */}
                {/* <div className="flex flex-col md:flex-row md:justify-center lg:justify-start gap-5 mt-8">
                  <Button title="GET STARTED" />
                  <Button varient="outlined" title="WATCH VIDEO" />
                </div> */}
              </div>

              {/* Hero Image */}
              <div>
                <img src={img1} className="hidden lg:block" alt="Hero Banner" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero1;